
import { defineComponent } from 'vue';
import { AvailableLoan } from '@/interfaces/loan';
import CollectionAlert from '@/components/Loans/Collections/CollectionAlert.vue';

export default defineComponent({
  name: 'CollectionAlerts',

  components: { CollectionAlert },

  computed: {
    activeLoanNumber(): string {
      return this.$store.getters['User/activeLoanNumber'];
    },

    loansInCollection(): AvailableLoan[] {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$store.getters['User/loansInCollection']
        .sort((a: AvailableLoan, b: AvailableLoan) => {
          if (a.loan_number === this.activeLoanNumber) {
            return -1;
          }
          if (b.loan_number === this.activeLoanNumber) {
            return 1;
          }

          return 0;
        });
    }
  }
});
